import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { mgcIconDelete2Regular } from '@sb/mgc-icons/mgcIcon-delete_2_regular.icon';
import { featureFlag } from '@sb/shared/feature';
import { usePermission } from '@sb/shared/permission/data-access';
import { IconRegistry } from '@sb/ui/icon';
import { yearList } from '@shiftbase-com/ts-shared/utilities';
import { getISOWeekYear } from 'date-fns';

import { AbsenteeOptionModel } from '../../../../reducers/orm/absentee-option/absentee-option.model';

@Component({
  standalone: false,
  selector: 'employee-plusmin-overview',
  templateUrl: './employee-plusmin-overview.component.html',
})
export class EmployeePlusminOverviewComponent {
  canEditPlusMinHours = usePermission(() => ({ permissions: ['Edit plus min hours'] }));

  years: string[] = [];
  private _year: string | number | null | undefined;
  showWeeks: Record<string, boolean> = {};
  features = featureFlag;

  currentYear = getISOWeekYear(new Date());

  @Input()
  title: string;
  @Input()
  stats;
  @Input()
  absenteeOptions: AbsenteeOptionModel[];
  @Input()
  userId: string;
  @Input()
  showAbsence: boolean;

  @Input()
  loadingStats: boolean;
  @Input()
  loadingCorrections: boolean;

  @Input()
  set year(year) {
    this._year = year;
    this.showWeeks = {};
  }

  get year() {
    return this._year;
  }

  @Input()
  set start(year: string | number | null | undefined) {
    this.updateYearOptions(year);
  }

  @Output()
  yearChange = new EventEmitter<string>();
  @Output()
  removeCorrection = new EventEmitter<string>();

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconDelete2Regular]);
  }

  private updateYearOptions(year: string | number | null | undefined) {
    if (!year) {
      return;
    }

    const startYear = Number(year) > this.currentYear ? this.currentYear : year;

    this.years = yearList(startYear, this.currentYear);
  }
}
